import { Stack, Tooltip, Typography } from '@mui/material';
import SegmentButton from 'ui-component/Segment/SegmentButton';
import { PermissionScope } from 'types/apps';

export function renderNumberWithStrikethrough({
  currentValue,
  strikethroughValue,
  tooltip,
  onClick,
  clickDisabled,
  currentValueColor,
  strikethroughColor,
  permissionScope,
  unitAbbreviation,
}: {
  currentValue: number;
  strikethroughValue: number | null;
  tooltip?: string;
  onClick?: () => void;
  clickDisabled?: boolean;
  currentValueColor?: string;
  strikethroughColor?: string;
  permissionScope?: PermissionScope;
  unitAbbreviation?: string;
}) {
  if (onClick && !clickDisabled) {
    return (
      <Tooltip title={tooltip || ''}>
        <SegmentButton
          onClick={onClick}
          sx={{ width: '100%', height: '100%', textTransform: 'none' }}
          permissionScope={permissionScope}
        >
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-end"
            sx={{ width: '100%', height: '100%' }}
          >
            {Boolean(strikethroughValue) && (
              <Typography
                variant="caption"
                sx={{
                  textDecoration: 'line-through',
                  color: strikethroughColor ?? 'default',
                }}
              >
                {strikethroughValue?.toLocaleString('en-US')}
                {unitAbbreviation && ` ${unitAbbreviation}`}
              </Typography>
            )}
            <Typography
              variant="body1"
              sx={{ color: currentValueColor ?? 'default' }}
            >
              {currentValue.toLocaleString('en-US')}
              {unitAbbreviation && ` ${unitAbbreviation}`}
            </Typography>
          </Stack>
        </SegmentButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip || ''}>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-end"
        sx={{ width: '100%', height: '100%' }}
      >
        {Boolean(strikethroughValue) && (
          <Typography
            variant="caption"
            sx={{
              textDecoration: 'line-through',
              color: strikethroughColor ?? 'default',
            }}
          >
            {strikethroughValue?.toLocaleString('en-US')}
            {unitAbbreviation && ` ${unitAbbreviation}`}
          </Typography>
        )}
        <Typography
          variant="body1"
          sx={{ color: currentValueColor ?? 'default' }}
        >
          {currentValue.toLocaleString('en-US')}
          {unitAbbreviation && ` ${unitAbbreviation}`}
        </Typography>
      </Stack>
    </Tooltip>
  );
}
